import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { getContractData } from '@shared/store/selectors';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class HasExpiredCardGuard implements CanActivate {
	constructor(
		private store: Store<any>,
		private router: Router
	) {}

	canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> {
		return this.store.pipe(
			select(getContractData),
			filter(x => x !== null),
			mergeMap(s => {
				if (
					(s.subscription?.spaq?.paymentMethod?.method === 'NotDefined' ||
						s.subscription?.spaq?.paymentMethod?.method === 'Cash') &&
					s.service?.serviceBillingType === 'AtBooking'
				) {
					return this.router.navigate(['/account/settings/cc/edit'], { queryParams: { expired: 1 } });
				}

				return of(true);
			})
		);
	}
}
